import { render, staticRenderFns } from "./QNotificationMenuPoliciesDialog.vue?vue&type=template&id=43c3d732&scoped=true&"
import script from "./QNotificationMenuPoliciesDialog.vue?vue&type=script&lang=js&"
export * from "./QNotificationMenuPoliciesDialog.vue?vue&type=script&lang=js&"
import style0 from "./QNotificationMenuPoliciesDialog.vue?vue&type=style&index=0&id=43c3d732&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c3d732",
  null
  
)

export default component.exports